import axios from 'axios';
export default class HttpClient {
    client;
    config = {};
    constructor(endpoint, options = {
        headers: {
            'Content-Type': 'application/json',
        },
    }) {
        this.client = axios.create({
            baseURL: endpoint,
            timeout: 15000,
            ...options,
        });
        this.config = {};
    }
    setConfig(config) {
        this.config = config;
        return this;
    }
    get(endpoint, params = {}) {
        return this.client.get(endpoint, { params, ...this.config });
    }
    post(endpoint, data = {}) {
        return this.client.post(endpoint, data, this.config);
    }
    put(endpoint, data = {}) {
        return this.client.put(endpoint, data, this.config);
    }
    delete(endpoint, params = {}) {
        return this.client.delete(endpoint, { params, ...this.config });
    }
}
